'use strict';

/** Import frontoffice_app */
import '../frontoffice_app';

/** Import Cart class */
import Cart from '../../../shared/cart/cart'

/**
 * @class ProductSingleHandler
 */
class ProductSingleHandler
{
    /**
     * @constructor
     */
    constructor ()
    {
        this._listenAlreadyInCart();
        this._listenAddToCart();
    }

    /**
     * @private
     */
    _listenAlreadyInCart ()
    {
        let
            itemData = $('#add_to_cart').data('cartitem').split('|'),
            slug = itemData[0],
            cart = Cart.getCartItems();

        $.each(cart, (k, v) =>
        {
            if (v.slug === slug)
            {
                $('#quantity').val(v.quantity);
            }
        })
    }

    /**
     * @private
     */
    _listenAddToCart ()
    {
        $('#add_to_cart').unbind('click').on('click', (e) =>
        {
            e.preventDefault();

            let quantity = $('#quantity').val();
            if (parseInt(quantity) > 0)
            {
                let
                    itemData = $(e.target).data('cartitem'),
                    itemDataStr = itemData + '|' + quantity;

                Cart.addToCartFromSinglePage(itemDataStr);
            }
        })
    }

}

/** Start ProductSingleHandler */
$(document).ready(() => { new ProductSingleHandler(); });


// WEBPACK FOOTER //
// ./assets/js/components/frontoffice/pages/product_single.js